import Mock, { Random } from 'mockjs';
import MockRequest, { AjaxDate } from '../MockRequest';

Random.extend({
  jobstatus() {
    const status = ['练习中', '考试中', '未开始', '已结束'];
    return this.pick(status);
  },
  pattern() {
    const p = ['练习模式', '考试模式'];
    return this.pick(p);
  },
});

export function queryJobView(data: AjaxDate) {
  const { pageNo = 1, pageSize = 15, totalRecords = 100 } = JSON.parse(data.body);
  return new MockRequest(
    Mock.mock({
      [`list|${pageSize}`]: [{
        id: '@guid',
        jobName: '作业-@cword(1,20)',
        className: '班级-@cword(1,20)',
        jobStatus: '@JOBSTATUS',
        pattern: '@pattern',
        startTime: '@date(yyyy/MM/dd hh:mm)',
        endTime: '@date(yyyy/MM/dd hh:mm)',
      }],
      pageNo,
      pageSize,
      totalRecords,
    }), '请求成功', true,
  );
}

export function delJobView(data: AjaxDate) {
  const { ids } = JSON.parse(data.body);
  return new MockRequest(
    ids, '删除成功', true,
  );
}

export function test() { return {}; }
